module.exports = __webpack_public_path__ + "img/title.4d33b2f2.png";